import * as React from "react";

import { useCustomerCartId, useCustomerSession } from "../../../Common";

import {
  ReactCheckout2022Route,
  useReactCheckout2022Router,
  useReactCheckout2022Router_asController,
} from "../react-checkout-2022-router-provider";

import { useMyBagDataSourceIntersection } from "./my-bag-data-source-intersection-provider";
import { useMyBagInitialization } from "./my-bag-initialization-provider";
import { useMyBagLoadingState } from "./my-bag-loading-state-provider";
import { useMyBagPresentationModel } from "./my-bag-presentation-model-provider";

export const MyBagAutoRoutes: React.FunctionComponent = (props) => {
  const { presentationMyBagItems, presentationMyBagOrder } =
    useMyBagPresentationModel();
  const { isLoading } = useMyBagLoadingState();
  const { hasInitialized } = useMyBagInitialization();
  const { mostLatestType } = useMyBagDataSourceIntersection();
  const { isCustomerLoggedIn } = useCustomerSession();
  const { cartId } = useCustomerCartId();

  const { currentRoute } = useReactCheckout2022Router();
  const { navigateTo } = useReactCheckout2022Router_asController();

  const mostLatestTypeIndicatesAnyResolve = React.useMemo(() => {
    const hasDataOrAnError =
      mostLatestType === "data" || mostLatestType === "error";

    const hasACartId = cartId && cartId.length > 0;
    const hasNothingAndShouldHaveNothing =
      mostLatestType === "none" && !hasACartId && !isCustomerLoggedIn;

    return !!(hasDataOrAnError || hasNothingAndShouldHaveNothing);
  }, [mostLatestType, cartId, isCustomerLoggedIn]);

  const hasAFullyFormedOrder = React.useMemo(() => {
    const eitherItHasTheOrderDetails_orThereShouldntBeAnyOrderDetails =
      presentationMyBagOrder ||
      ((!cartId || cartId.length < 1) && !isCustomerLoggedIn);
    return eitherItHasTheOrderDetails_orThereShouldntBeAnyOrderDetails;
  }, [presentationMyBagOrder, cartId, isCustomerLoggedIn]);

  const hasThePageDataLoadedSuchThatICanAutoRouteIfNeedBe =
    React.useMemo(() => {
      return (
        hasInitialized &&
        !isLoading &&
        mostLatestTypeIndicatesAnyResolve &&
        hasAFullyFormedOrder
      );
    }, [
      hasInitialized,
      isLoading,
      mostLatestTypeIndicatesAnyResolve,
      hasAFullyFormedOrder,
    ]);

  const autoRoute = React.useCallback(() => {
    if (!hasThePageDataLoadedSuchThatICanAutoRouteIfNeedBe) {
      return;
    }

    let shouldBeHere: ReactCheckout2022Route | undefined;

    if (currentRoute !== "success" && presentationMyBagItems.length === 0) {
      shouldBeHere = ReactCheckout2022Route.mybag;
    }

    // if (
    //   currentRoute === "delivery-details" &&
    //   presentationMyBagOrder?.isThisAVirtualOrder
    // ) {
    //   shouldBeHere = ReactCheckout2022Route.payment;
    // }

    if (shouldBeHere && currentRoute !== shouldBeHere) {
      navigateTo(shouldBeHere);
    }
  }, [
    hasThePageDataLoadedSuchThatICanAutoRouteIfNeedBe,
    presentationMyBagItems,
    navigateTo,
    currentRoute,
    presentationMyBagOrder,
  ]);

  React.useEffect(() => {
    autoRoute();
  }, [
    hasThePageDataLoadedSuchThatICanAutoRouteIfNeedBe,
    autoRoute,
    presentationMyBagItems,
    presentationMyBagOrder,
    currentRoute,
    cartId,
    isCustomerLoggedIn,
  ]);

  return <React.Fragment>{props.children || []}</React.Fragment>;
};
